// Custom legal-notice-compliance html element
if (!customElements.get("legal-notice-compliance")) {
  class LegalNoticeCompliance extends HTMLElement {
    constructor() {
      super();
    }

    updateCheckoutButtons() {
      this.checkoutButtons = document.querySelectorAll(".cart__checkout-button");

      this.checkoutButtons.forEach((button) => {
        if (this.tradingConditionComplianceBool) {
          button.disabled = false;
        } else {
          button.disabled = true;
        }
      });
    }

    updateTradingConditionCompliance() {
      if (this.tradingConditionsCompliance.checked) {
        this.tradingConditionComplianceBool = true;
      } else {
        this.tradingConditionComplianceBool = false;
      }
      // this.updateCheckoutButtons();
    }

    async _onSubmit (event) {
      this.updateTradingConditionCompliance();
      if (!this.tradingConditionComplianceBool) { // Please accept the trading conditions to proceed.
        event.preventDefault();
        event.stopImmediatePropagation();

        this.complianceError.style.visibility = "visible";


        this.classList.add("invalid-shake");
      }
    }

    setup_items() {
      this.tradingConditionComplianceBool = false;
      this.tradingConditionsCompliance = this.querySelector(
        ".checkbox-trading-condition-compliance"
      );
      // this.checkoutButtons = document.querySelectorAll(".cart__checkout-button");
      this.cart_footer = this.closest(".cart__footer");
      if (!this.cart_footer) {
        this.cart_footer = this.closest(".drawer__footer");
      }

      this.checkoutButtons = this.cart_footer.querySelector(".cart__checkout-button");

      this.tradingConditionsCompliance.addEventListener(
        "change",
        this.updateTradingConditionCompliance.bind(this)
      );

      // this.checkoutButtons.forEach((button) => {
      //   button.addEventListener("click", this._onSubmit.bind(this));
      // });
      this.checkoutButtons.addEventListener("click", this._onSubmit.bind(this));

      this.addEventListener("animationend", (event) => {
        if (event.animationName === "invalid-shake") {
          this.classList.remove("invalid-shake");
        }
      });

      this.complianceError = this.querySelector(".trading-condition-compliance-error");
      this.complianceError.style.visibility = "hidden";

      this.updateTradingConditionCompliance();
    }

    connectedCallback() {
      this.setup_items();
    }
  }
  customElements.define("legal-notice-compliance", LegalNoticeCompliance);
}